import { connect } from 'react-redux';

import Component from './D2bTable.component';

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
